import './Recent.scss';
import {  
  CarouselSlider,
  Skeleton,
  SkeletonItem,
} from "@fluentui/react-components";
import {
  Carousel,  
  CarouselCard,
  CarouselNav,
  CarouselNavButton,
  CarouselNavContainer,
  CarouselViewport,
} from "@fluentui/react-components";
import { Text, Card, CardPreview, Image as FImage } from "@fluentui/react-components";
import { useState } from "react";
import { getLatestImages } from '../../../services/search-image.service';
import { useAuth } from "../../../auth/AuthProvider";

function Recent()
{
    const {user} = useAuth(); 
    const [results, setResults] = useState(getRecent); 

    async function getRecent()
    {
        try
        {
            let email = user;
                                
            const data = await getLatestImages(
                email, {timeoutMs: 60000}
            );
            
            const imgs = (data?.images ?? []).map((img) => ({
                id: img.id,
                name: img.name,
                // API already returns a full data URL; if not, build it:
                src: img.data?.startsWith("data:")
                ? img.data
                : `data:${img.contentType || "image/*"};base64,${img.data}`,
            }));
            
            setResults(imgs);
            
        }
        catch(err)
        {
            setResults([]);
        }
    }

    return(
        <>
        {results && <div className='d-flex justify-content-center'>
                <h4>
                Latest update
                </h4>
        </div> }
        
        {results && <div className="d-flex justify-content-center">
            <Carousel draggable>
                <CarouselViewport>
                    <CarouselSlider>
                        {!!results.length && results.map((img) => (
                            <CarouselCard autoSize style={{padding:'10px'}} className="latest-carrusel-slider">
                                <Card key={img.id} className="latest-card-size">
                                    <CardPreview className='latest-card-preview'>                                        
                                        <FImage className="latest-result-slider" src={img.src} alt={img.name || img.id} fit="contain"/>                                        
                                    </CardPreview>                                    
                                </Card>
                            </CarouselCard>                        
                        ))}                                                                       
                    </CarouselSlider>
                </CarouselViewport>

                {!!results.length && (<CarouselNavContainer
                    layout="inline"
                    next={{ "aria-label": "go to next" }}
                    prev={{ "aria-label": "go to prev" }}
                >
                <CarouselNav>
                {(index) => (
                    <CarouselNavButton aria-label={`Carousel Nav Button ${index}`} />
                )}
                </CarouselNav>
                </CarouselNavContainer>)}
            </Carousel>            
        </div> }
        {!results && <Skeleton><SkeletonItem/></Skeleton>}
        </>
    );
}

export default Recent;